import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import type {
  EventqDetectionBoundingBoxActivate,
  EventqDetectionEventType,
} from './detection-bounding-box.types';
import { DETECTION_BOUNDING_BOX_ICON_SRC } from './detection-bounding-box.types';
import { prefixUrl } from '../../utils/url.util';

@Component({
  selector: 'eventq-detection-bounding-box',
  templateUrl: './detection-bounding-box.html',
  styleUrl: './detection-bounding-box.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.--eventq-detection-mask-motion]': 'detectionMaskMotion()',
    '[style.--eventq-detection-mask-human]': 'detectionMaskHuman()',
    '[style.--eventq-detection-mask-vehicle]': 'detectionMaskVehicle()',
    '[style.--eventq-detection-mask-gun]': 'detectionMaskGun()',
  },
})
export class EventqDetectionBoundingBox {
  readonly eventType = input.required<EventqDetectionEventType>();
  readonly x = input.required<number>();
  readonly y = input.required<number>();
  readonly width = input.required<number>();
  readonly height = input.required<number>();
  readonly clickable = input(false);
  readonly animated = input(true);
  readonly ariaLabel = input<string | null>(null);

  readonly activated = output<EventqDetectionBoundingBoxActivate>();

  readonly positionStyle = computed(() => ({
    left: `${this.x()}%`,
    top: `${this.y()}%`,
    width: `${this.width()}%`,
    height: `${this.height()}%`,
  }));

  readonly resolvedAriaLabel = computed(
    () => this.ariaLabel() ?? `AI detection ${this.eventType()}`,
  );

  readonly detectionMaskMotion = computed(() =>
    this.maskUrl(DETECTION_BOUNDING_BOX_ICON_SRC.motion),
  );
  readonly detectionMaskHuman = computed(() => this.maskUrl(DETECTION_BOUNDING_BOX_ICON_SRC.human));
  readonly detectionMaskVehicle = computed(() =>
    this.maskUrl(DETECTION_BOUNDING_BOX_ICON_SRC.vehicle),
  );
  readonly detectionMaskGun = computed(() => this.maskUrl(DETECTION_BOUNDING_BOX_ICON_SRC.gun));

  onActivate(event: Event): void {
    if (!this.clickable()) {
      return;
    }

    this.activated.emit({ anchorElement: event.currentTarget as HTMLElement });
  }

  private maskUrl(logicalPath: string): string {
    return `url(${prefixUrl(logicalPath)})`;
  }
}
